/*!

=========================================================
* Vue Argon Dashboard - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import i18n from './i18n'
import './registerServiceWorker'
import axios from './backend/vue-axios'
import store from './store'
import ArgonDashboard from './plugins/argon-dashboard'
import VueLuxon from "vue-luxon"

Vue.use(VueLuxon, {
  input: {
      zone: "utc",
      format: "iso"
  },
  output: "med"
});

Vue.config.productionTip = false

Vue.use(ArgonDashboard)
new Vue({
  router,
  i18n,
  axios,
  store,
  render: h => h(App)
}).$mount('#app')
